module.exports = __webpack_public_path__ + "static/img/3.874781a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/common/document/3/3.png
// module id = xqAP
// module chunks = 1